export const environment = {
  production: true,
  environment: "ステージング環境",
  apiHost: "le-base-stg.facere.biz",
  previewUrl: "https://stg.enta-go.com",
  firebase: {
    apiKey: "AIzaSyCR0v6Lcg8zE84bpIxm-QMfOZwaTvRZ4tM",
    authDomain: "le-base-stg.firebaseapp.com",
    projectId: "le-base-stg",
    storageBucket: "le-base-stg.firebasestorage.app",
    messagingSenderId: "774710625400",
    appId: "1:774710625400:web:26837d16be59671f2c198d",
    measurementId: "G-M8RF9B4JDP"
  },
  apiRootUrl: "https://asia-northeast1-le-base-stg.cloudfunctions.net",
  staffSiteLoginUrl: "https://stg.staff.enta-go.com/qrreader",
  googleAnalytics4ReportUrl: "https://lookerstudio.google.com/embed/reporting/5f28c0fa-fdde-4738-a2ff-681cfccac4f6/page/tEnnC",
  allowIps: [
    "20.89.176.108",
    "133.158.251.220",
    "133.158.251.221",
    "133.158.251.222",
    "133.158.251.223"
  ]
};
